import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {BaseFormElementComponent} from '../base-form-element.class';
import {NgbDateAdapter, NgbDateParserFormatter, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {DateValidator, EsvgFiles} from 'frontier/nucleus';
import {IDateFormElement} from '../form-data.interface';
import {
  GermanDatepickerAdapter,
  GermanDatepickerFormatter
} from 'frontier/browserkit/src/lib/components/bootstrap-datepicker-adapter/german-datepicker-adapter.service';
import {AbstractControl, FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Subscription} from 'rxjs';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {RemoveDatepickerValidationDirective} from '../../../../../../directives/remove-datepicker-validation.directive';
import {MatInput} from '@angular/material/input';
import {NgFor} from '@angular/common';
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field';
import {DateTime} from 'luxon';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import {DateFormatterService} from "frontier/browserkit/src/lib/services/date-formatter.service";

@Component({
  selector: 'kpi4me-date-element',
  templateUrl: './date-element.component.html',
  styleUrls: ['./date-element.component.scss', '../form-element.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [
    {provide: NgbDateAdapter, useClass: GermanDatepickerAdapter},
    {provide: NgbDateParserFormatter, useClass: GermanDatepickerFormatter},
  ],
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    NgbInputDatepicker,
    FormsModule,
    RemoveDatepickerValidationDirective,
    ReactiveFormsModule,
    MatIconButton,
    MatSuffix,
    MatIcon,
    MatError,
    NgFor,
  ],
})
export class DateElementComponent extends BaseFormElementComponent implements OnDestroy {
  private dateFormatterService: DateFormatterService = inject(DateFormatterService);
  @ViewChild(NgbInputDatepicker) datePickerRef: NgbInputDatepicker;
  @ViewChild('inputRef', {static: true}) inputRef: ElementRef;

  private subs = new Subscription();
  protected readonly EsvgFiles = EsvgFiles;

  private _initialValue: string;

  override _formControlElement: AbstractControl;

  startDate: NgbDateStruct

  @Input() customValidatorMessage: Map<string, string> = new Map();

  @Input()
  override set formControlElement(c: AbstractControl) {
    if (c) {
      this._initialValue = DateTime.fromISO(c.value).toFormat('yyyy-MM-dd');
      this.startDate = this.ngbDateAdapter.fromModel(this._initialValue)
      this._formControlElement = c;
      this.getFormControl().addValidators(DateValidator.isoFormat);
      this.getFormControl().updateValueAndValidity();
      this.cdr.detectChanges();
    }
  };

  override get formControlElement(): FormControl {
    return this._formControlElement as FormControl;
  }

  constructor(private cdr: ChangeDetectorRef,
              private renderer: Renderer2,
              private ngbDateAdapter: NgbDateAdapter<string>) {
    super();
  }

  @Input()
  override set data(form: IDateFormElement) {
    this.getFormControl().addValidators(DateValidator.isoFormat);

    super.data = form;

    this.getFormControl().updateValueAndValidity();
  };

  @Output() selectionChange = new EventEmitter();

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  getErrorMessage(): string[] {
    const formControl = this.getFormControl();
    const errorMessage: string[] = [];
    if (formControl.hasError('required')) {
      errorMessage.push('Bitte geben Sie ein Datum an.');
    }
    if (formControl.hasError('noIsoFormat')) {
      errorMessage.push('Der eingegebene Wert ist kein Gültiges Datum im Format TT.MM.JJJJ.')
    }
    this.customValidatorMessage.forEach((value: string, key: string) => {
      if (formControl.hasError(key)) {
        errorMessage.push(value);
      }
    })
    return errorMessage;
  }

  override onFocusOut(evt: FocusEvent) {
    return;
  }

  onInputChange(event: Event): void {
    const input: HTMLInputElement = event.currentTarget as HTMLInputElement;
    this.dateFormatterService.formatDateOnInput(input);
  }

  dateChange() {
    if (
      DateTime.fromISO(this._formControlElement.value).toFormat('yyyy-MM-dd') === this._initialValue
    ) {
      return;
    }
    this.modelChange.emit(this.formControlElement);
  }
}
